import { createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import { enumTranslator, isNullObject } from '../../utils';
import * as AllActions from '../action';
import AllActionTypes from '../actionType';
import { makeFetchSuccessActionType } from '../../event/fetchActionTypeProvider';
const initialState: any = {
  total: 0,
  data: [],
  timestamp: 0,
};

const handleUpdateAlarmRecord = (
  state: typeof initialState,
  response: HTTPResponse,
  eventType: 'ISSUE_LIST' | 'JIRA_RECORD' | 'ERROR_RECORD' | 'ALARM_RECORD',
) => {
  const { data } = response;
  state.total = data.total;
  state.data = data.list.map((item: any, index: number) => {
    let obj = {};
    if (eventType === AllActionTypes.JIRA_RECORD) {
      // 提报信息
      const { city, reportUser, station, vehicle, isReported } =
        item.assistJiraRecord;
      obj = {
        ...item.assistJiraRecord,
        cityName: city && city.name,
        stationName: station && station.name,
        vehicleName: vehicle && vehicle.name,
        reportUser: reportUser && reportUser.username,
        debugTime: item.debugTime,
        linkedExceptionLogs: item.linkedExceptionLogs,
        attachmentName: item.attachmentName,
        isReported,
        key: index,
      };
    } else if (eventType === AllActionTypes.ISSUE_LIST) {
      // 报警工单
      obj = { ...item };
    } else {
      obj = {
        ...item,
        cityName: item.city && item.city.name,
        stationName: item.station && item.station.name,
        vehicleName: item.vehicle && item.vehicle.name,
        solverName: item.user && item.user.username,
        errorEvent: enumTranslator('ALARM_EVENT_ENUM', item.errorEvent),
        key: index,
      };
    }
    return obj;
  });
  state.timestamp = Date.now();
  state.issueDetail = null;
};

const warningListPageState = createSlice({
  name: 'warningListPage',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        makeFetchSuccessActionType(AllActionTypes.ALARM_RECORD),
        (state, action: any) => {
          const response = action.payload;
          handleUpdateAlarmRecord(state, response, AllActionTypes.ALARM_RECORD);
        },
      )
      .addCase(
        makeFetchSuccessActionType(AllActionTypes.ERROR_RECORD),
        (state, action: any) => {
          const response = action.payload;
          handleUpdateAlarmRecord(state, response, AllActionTypes.ERROR_RECORD);
        },
      )
      .addCase(
        makeFetchSuccessActionType(AllActionTypes.JIRA_RECORD),
        (state, action: any) => {
          const response = action.payload;
          handleUpdateAlarmRecord(state, response, AllActionTypes.JIRA_RECORD);
        },
      )
      .addCase(
        makeFetchSuccessActionType(AllActionTypes.ISSUE_LIST),
        (state, action: any) => {
          const response = action.payload;
          handleUpdateAlarmRecord(state, response, AllActionTypes.ISSUE_LIST);
        },
      )
      .addCase(AllActions.actionClearAlarmRecordList, (state, action) => {
        state.total = 0;
        state.data = [];
        state.timestamp = 0;
      })
      .addCase(AllActions.actionSubmitJIRAIssue, (state, action) => {
        const response = action.payload;
        if (response.errorCode != 0) {
          message.warning(response.message);
          state.timestamp = Date.now();
          return;
        }
        const { assistJiraRecord } = response.data;
        if (!isNullObject(assistJiraRecord)) {
          const { id, reportUser, city, station, vehicle, isReported } =
            assistJiraRecord;
          const { data } = state;
          if (data) {
            const index = data.findIndex((item: any) => item.id === id);
            const item = data[index];
            const obj = {
              ...item,
              ...assistJiraRecord,
              cityName: city && city.name,
              stationName: station && station.name,
              vehicleName: vehicle && vehicle.name,
              reportUser: reportUser && reportUser.username,
              isReported,
              key: Date.now(),
            };
            data.splice(index, 1, obj);
            state.data = data;
          }
        }
      });
  },
});

export default warningListPageState.reducer;
